import { sizes } from '@lmc/common/constants'
import { Button, EmptyState, Icon, NoDataIcon, PageHeader } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import { showToast } from '../../../../common/utils'
import { Spinner } from '../../../../components/generic'
import Operations from '../../../../operations'
import { PreferencesBanner } from '../DeviceAccessScreen/components/PreferencesBanner'
import { ShiftPasswordsList } from './components'
import {
  NO_SHIFTS_DESC,
  NO_SHIFTS_MESSAGE,
  SUPPORT_LINK
} from './components/constants'

export class ShiftPasswordsScreen extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    deleteDialogOpen: false
  }

  componentDidMount() {
    if (this.props.home.features?.shifts?.enabled) {
      this.props.fetchShifts()
    }
  }

  handleDelete = (id) => {
    this.props.deleteShift(id)
    showToast({ type: 'info', title: 'Deleted a Shift' })
  }

  render() {
    const { shifts, deleteShift, openModal, home } = this.props

    const hasShiftsEnabled = home.features?.shifts?.enabled

    const isLoading = shifts === undefined

    const hasShifts = !!shifts?.length

    return (
      <div style={styles.mainContainer} data-testid="shift-passwords-screen">
        <PageHeader title="Shift Passwords" testId="shift-passwords-header">
          <Button
            onClick={openModal}
            style={styles.addButton}
            variant="primary"
            icon={<Icon name="PlusOutlined" />}
            disabled={!hasShiftsEnabled}
            data-testid="add-shift-password-button"
          >
            Add a Shift Password
          </Button>
        </PageHeader>
        {!hasShiftsEnabled && (
          <PreferencesBanner
            title="You haven't enabled Shift Passwords in "
            testId="shift-passwords-banner"
          />
        )}
        <div
          style={styles.innerWrapper}
          data-testid="shift-passwords-content"
        />
        {hasShiftsEnabled && !isLoading && hasShifts && (
          <ShiftPasswordsList
            shifts={shifts}
            onDelete={deleteShift}
            testId="shift-passwords-list"
          />
        )}
        {hasShiftsEnabled && isLoading && (
          <Spinner data-testid="shift-passwords-loading" />
        )}
        {(!hasShifts || !hasShiftsEnabled) && (
          <EmptyState
            title={NO_SHIFTS_MESSAGE}
            description={NO_SHIFTS_DESC}
            icon={<NoDataIcon />}
            testId="shift-passwords-empty"
          >
            <a
              href={SUPPORT_LINK}
              rel="noreferrer"
              target="_blank"
              data-testid="shift-passwords-support-link"
            >
              Find out more
            </a>
          </EmptyState>
        )}
      </div>
    )
  }
}

const styles = {
  addButton: {
    float: 'right'
  },
  mainContainer: {
    padding: '24px',
    overflow: 'auto',
    height: '83vh',
    margin: '0 auto',
    width: '100%',
    maxWidth: sizes.childScreen,
    wordWrap: 'break-word'
  },
  innerWrapper: {
    marginTop: 24
  }
}

ShiftPasswordsScreen.propTypes = {
  shifts: PropTypes.array,
  home: PropTypes.object
}

const mapStateToProps = (state) => ({
  shifts: state.data.shifts,
  home: state.global.home
})

const mapDispatchToProps = (dispatch) => ({
  fetchShifts: () => dispatch(Operations.loadList('shifts')),
  deleteShift: (id) => dispatch(Operations.deleteShift(id)),
  openModal: () => {
    const id = 'addShift'
    dispatch(Actions.openModal({ modalId: id }))
    dispatch(Actions.addForm({ formId: id }))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShiftPasswordsScreen)
